import { useMemo } from 'react';
import { useEntities } from '../api/queries/entities';

/**
 * Given entity IDs, returns a lookup map of id -> name.
 * Uses the entity list query as cache source.
 */
export function useEntityNames(
  entityIds: string[],
  bookId?: string,
): Map<string, string> {
  const bookEntities = useEntities({
    projectId: bookId,
    scope: 'book',
    pageSize: 200,
  });
  const privateEntities = useEntities({ scope: 'private', pageSize: 200 });

  return useMemo(() => {
    const map = new Map<string, string>();
    const all = [
      ...(bookEntities.data?.items ?? []),
      ...(privateEntities.data?.items ?? []),
    ];
    for (const entity of all) {
      if (entityIds.includes(entity.id)) {
        map.set(entity.id, entity.name);
      }
    }
    return map;
  }, [bookEntities.data, privateEntities.data, entityIds]);
}
